import React from 'react'
import HeaderSix from '../components/header/HeaderSix'
import FooterSix from '../components/footer/FooterSix'
import IndustriesBreadcrumb from '../components/techdigit/industries/IndustriesBreadcrumb'
import IndustriesHero from '../components/techdigit/industries/IndustriesHero'
import IndustriesIntroStrip from '../components/techdigit/industries/IndustriesIntroStrip'
// import IndustriesCards from '../components/techdigit/industries/IndustriesCards'
import IndustriesCardStack from '../components/techdigit/industries/IndustriesCardStack'
import IndustriesOpenDoor from '../components/techdigit/industries/IndustriesOpenDoor'
import IndustriesFaq from '../components/techdigit/industries/IndustriesFaq'
import ScrollAnimation from '../components/motion/ScrollAnimation'

function Industries() {
    return (
        <div className="index-six industries-page">
            <HeaderSix />
            <main>
                <ScrollAnimation direction="fade" delay={0.03} duration={0.38}>
                    <IndustriesBreadcrumb />
                </ScrollAnimation>
                <ScrollAnimation direction="up" delay={0.06} duration={0.5}>
                    <IndustriesHero />
                </ScrollAnimation>
                <ScrollAnimation direction="left" delay={0.08} duration={0.52}>
                    <IndustriesIntroStrip />
                </ScrollAnimation>
                {/* <ScrollAnimation direction="up" delay={0.06} duration={0.48}>
                    <IndustriesCards />
                </ScrollAnimation> */}
                <ScrollAnimation direction="up" delay={0.06} duration={0.48}>
                    <IndustriesCardStack />
                </ScrollAnimation>
                <ScrollAnimation direction="right" delay={0.08} duration={0.52}>
                    <IndustriesOpenDoor />
                </ScrollAnimation>
                <ScrollAnimation direction="fade" delay={0.04} duration={0.42}>
                    <IndustriesFaq />
                </ScrollAnimation>
            </main>
            <FooterSix />
        </div>
    )
}

export default Industries
